import React from 'react';
import PropType from 'prop-types';


import Button from '@Components/Button';


import './ExportButton.scss';


export default function ExportButton (props) {
  const { isExportEnabled, openExportDialog } = props;

  return (
    <Button
      onClick={() => {
        openExportDialog();
      }}
      disabled={!isExportEnabled}
      buttonConfig={{
        className: 'result-toolbar-export-button',
        label: 'Export',
        type: 'link',
        size: 'tiny',
        e2eName: 'export',
      }}
      iconConfig={{
        position: 'before',
        name: 'upload',
        size: 'sm',
      }}
    />
  );
}

ExportButton.defaultProps = {
  openExportDialog: () => {
    Logger.error('openExportDialog something went wrong, value from ng is not a function');
  },
};

ExportButton.propType = {
  openExportDialog: PropType.func,
  isExportEnabled: PropType.bool,
};

